import { storeRoutes } from 'modules/store/routes/constants';

export const storeCartRoutes = {
  cart: `${storeRoutes.root}/cart`,
};
